export default ({ COLORS, BREAKPOINTS }) => ({
  container: {
    position: 'fixed',
    width: '100%',
    bottom: '0',
    left: '0',
    backgroundColor: '#fff',
    boxShadow: '0 -2px 4px 0 rgba(0, 0, 0, 0.1)',
    color: COLORS.TEXT.MID_GREY.NORMAL,
    pointerEvents: 'none',
    transform: 'translateY(80px)',
    transition: 'transform .2s ease-out'
  },
  show: {
    pointerEvents: 'auto',
    transform: 'translateY(0)'
  },
  contentHolder: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '80px',
    padding: '0 42px'
  },
  buttonIcon: {
    margin: '0 8px 0 0'
  },
  selected: {
    margin: '0 10px 0 0'
  },
  showSelected: {
    color: COLORS.BLUE.NORMAL,
    fontWeight: 'bold',
    cursor: 'pointer',
    [`@media (max-width: ${BREAKPOINTS.XS})`]: {
      display: 'block'
    }
  }
})
